/// REACT ///
import { useState } from "react";
/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// ACTIONS ///
import { createStripeSession } from "api/actions/billing";
/// MUI ///
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
/// HOC ///
import LoadingPage from "components/universal/loading_page";
/// ICONS ///
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
/// STYLES ///
import { planCardStyle } from "styles/marketing";
/// COLORS ///
import { text_primary } from "styles/style";
/// VALUES ///
import { MONTHLY_PRICE_ID } from "settings";

export default function SubscriptionSetup() {
  const dispatch = useAppDispatch();
  const [load, setLoad] = useState<boolean>(false);
  const { user } = useAppSelector(state => state.authentication);
  const { session } = useAppSelector(state => state.billing);

  const handleCreateSession = () => {
    setLoad(true);
    if (user?.customer_id !== "") {
      dispatch(createStripeSession(user?.customer_id, MONTHLY_PRICE_ID));
    }
  }

  if (session && session.session_url) {
    window.location.href = session.session_url;
  }

  return (
    <LoadingPage loading={load}>
      <Grid container>
        <Grid item xs={2}></Grid>
        <Grid item xs={4} sx={{display: "flex", justifyContent: "flex-end", paddingTop: "50px", paddingRight: "70px"}}>
          <Paper sx={planCardStyle} elevation={5}>
            <Stack alignItems="center">
              <Typography variant="h6" sx={{color: text_primary}} textAlign="center">
                  Arris Subscription
              </Typography>
              <Stack direction="row" sx={{paddingTop: 1}} justifyContent="center">
                  <Typography variant="body2">
                      $
                  </Typography>
                  <Typography variant="h1" sx={{padding: 0, margin: 0}}>
                      199
                  </Typography>
              </Stack>
              <Typography variant="body2" textAlign="center">
                  Every month
              </Typography>
              <Typography variant="body1" textAlign="center" sx={{fontSize: 15, paddingTop: 1}}>
                  Billed Monthly
              </Typography>
              <Typography variant="body2" textAlign="center" sx={{paddingTop: 2}}>
                  14 day free trial
              </Typography>
            </Stack>
            <Stack alignItems="left">
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                      Access to all drawing and cost projection tools
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                      Free onboarding training session to make you an Arris expert
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                    Limited Time Offer: Access to the Scheduler at no additional cost
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                      A vast repository of knowledge and resources
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                      Complete features for task scheduling and project management
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}} justifyContent="flex-start">
                  <Icon color="primary" fontSize="small">
                      <CheckCircleIcon fontSize="small"/>
                  </Icon>
                  <Typography variant="body2" sx={{marginLeft: 2}}>
                      Freedom to cancel at any time
                  </Typography>
              </Stack>
              <Stack direction="row" sx={{paddingTop: 3}}>
                  <Typography variant="body2" textAlign="center">
                  <span>&nbsp;</span>{"\n"}
                  <span>&nbsp;</span>{"\n"}
                  <span>&nbsp;</span>
                  </Typography>
              </Stack>
            </Stack>
          </Paper>
        </Grid>
        <Grid item xs={6} sx={{paddingTop: "50px"}}>
          <Stack>
            <Typography variant="body2" sx={{ paddingTop: 3.25, paddingBottom: 4.5 }}>
              Proceed to our secure payment portal to complete your subscription.
              You will not be charged for 14 days during the free trial period.
            </Typography>
            {
              !user?.customer_id ?
                <Stack direction="row" sx={{ width: "100%", justifyContent: "center" }} alignItems="center" spacing={6}>
                  <Typography variant="body2" color="primary">
                    <b>Loading</b>
                  </Typography>
                  <CircularProgress size={24} />
                </Stack> :
                <Button variant="contained" onClick={handleCreateSession}>
                  Setup Payment
                </Button>
            }
          </Stack>
        </Grid>
      </Grid>
    </LoadingPage>
  );
}
